import React, {useState,useEffect} from "react";
import {Card,Button,Modal,Form} from "react-bootstrap";
import {FiClock} from "react-icons/fi";

export default function AttendanceCard(){

const [show,setShow]=useState(false);
const [isPunched,setIsPunched]=useState(false);
const [startTime,setStartTime]=useState(null);
const [totalTime,setTotalTime]=useState("00:00:00");


// TIMER
useEffect(()=>{

let timer;

if(isPunched && startTime){

timer=setInterval(()=>{

const now=new Date();
const diff=now-startTime;

const hours=Math.floor(diff/3600000);
const minutes=Math.floor((diff%3600000)/60000);
const seconds=Math.floor((diff%60000)/1000);

setTotalTime(
`${hours.toString().padStart(2,"0")}:
${minutes.toString().padStart(2,"0")}:
${seconds.toString().padStart(2,"0")}`
);

},1000);

}

return()=>clearInterval(timer);

},[isPunched,startTime]);


const handlePunchIn=()=>{
setShow(true);
};

const confirmPunchIn=()=>{
setStartTime(new Date());
setIsPunched(true);
setShow(false);
};

const handlePunchOut=()=>{
setIsPunched(false);
};

const today=new Date().toLocaleString("en-IN",{
hour:"2-digit",
minute:"2-digit",
day:"2-digit",
month:"short",
year:"numeric"
});

return(

<>
<Card className="attendance-card h-100">

<Card.Body>

<div className="text-center mb-3">

<h6 className="attendance-title">Attendance</h6>

<h5 className="time-text">{today}</h5>

</div>


{/* Circle Progress */}

<div className="circle-progress">

<div className="circle-inner">

<span>Total Hours</span>

<h5>{totalTime}</h5>

</div>

</div>


<div className="text-center mt-4">

<div className="production-badge">

Production : 3.45 hrs

</div>

<h6 className="punch-text">

<FiClock className="text-orange me-1"/>

{isPunched ? "Working..." : "Punch In at 10.00 AM"}

</h6>


<Button
className="w-100 punch-btn"
onClick={isPunched ? handlePunchOut : handlePunchIn}
>

{isPunched ? "Punch Out" : "Punch In"}

</Button>

</div>

</Card.Body>

</Card>


{/* Punch Modal */}

<Modal show={show} onHide={()=>setShow(false)} centered>

<Modal.Header closeButton>

<Modal.Title>Punch In</Modal.Title>

</Modal.Header>

<Modal.Body>

<Form>

<Form.Group>

<Form.Label>Working Location</Form.Label>

<Form.Select>

<option>Office</option>

<option>Work From Home</option>

</Form.Select>

</Form.Group>

</Form>

</Modal.Body>

<Modal.Footer>

<Button variant="secondary" onClick={()=>setShow(false)}>
Cancel
</Button>

<Button variant="primary" onClick={confirmPunchIn}>
Confirm Punch In
</Button>

</Modal.Footer>

</Modal>


<style>
{`

.attendance-card{
border:1px solid #ff6b2c;
border-radius:8px;
background:#faf7f4;
}

.attendance-title{
background:#ff6b2c;
color:white;
padding:3px 8px;
font-size:11px;
border-radius:4px;
display:inline-block;
}

.time-text{
font-weight:700;
color:#1a2b49;
}

.circle-progress{
width:165px;
height:165px;
border-radius:50%;
border:6px solid #1bb15d;
margin:auto;
display:flex;
align-items:center;
justify-content:center;
background:white;
}

.circle-inner{
text-align:center;
}

.circle-inner span{
font-size:13px;
color:#777;
}

.circle-inner h5{
font-weight:700;
margin-top:4px;
}

.production-badge{
background:#1f1f1f;
color:white;
padding:6px 14px;
border-radius:6px;
display:inline-block;
margin-bottom:12px;
font-size:14px;
}

.text-orange{
color:#ff6b2c;
}

.punch-btn{
background:#ff6b2c;
border:none;
padding:10px;
font-weight:600;
}

.punch-btn:hover{
background:#ff5a1a;
}

@media(max-width:1024px){

.attendance-card{
margin-top:20px;
}

}

`}
</style>

</>
)

}